import React from "react"

import { NetworkProvider } from "./src/components/network"
import wrapPage from "./src/intl/wrap-page"

export const wrapPageElement = wrapPage

export const wrapRootElement = ({ element }) => (
  <NetworkProvider>{element}</NetworkProvider>
)
